// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  WEBSITE_URL: 'https://www.gofriday.ai',
  API_BASE_URL: 'https://website-service.gofriday.ai',
  BUCKET_URL: 'https://admin-assets.gofriday.ai/',
  CALENDLY_URL: 'https://calendly.com/gofriday_/30min',
  LINKEDIN_URL: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  RECAPTCHA_SITE_KEY: '6LeFgH0qAAAAAGYVP30iZjJFsJgixitU8pQoGqLv',
  EMAIL_PATTERN: '^(?!.{201})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
  PASSWORD_PATTERN: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
